import { action, makeObservable, observable } from 'mobx'

export class FormValidation<TField extends string> {
  @observable private isSubmitAttempted = false
  private readonly touchedFields = observable.set<TField>()

  public constructor(private readonly getErrors: () => Record<TField, string>) {
    makeObservable(this)
  }

  public errorOf = (field: TField): string =>
    this.isSubmitAttempted || this.touchedFields.has(field)
      ? this.getErrors()[field]
      : ''

  // An empty field only reports "Enter …" on submit: people tab through fields or step out
  // to a picker before typing.
  @action.bound
  public touch(field: TField, value: string) {
    if (value.trim()) {
      this.touchedFields.add(field)
    }
  }

  @action.bound
  public attemptSubmit(): TField | null {
    const errors = this.getErrors()
    const invalidField = (Object.keys(errors) as TField[]).find(
      field => errors[field],
    )
    if (!invalidField) {
      return null
    }

    this.isSubmitAttempted = true
    return invalidField
  }
}
